export type MenuItem = {
  title: string
  icon?: string // Remix icon class
  iconSrc?: string // Image path
  color: 'success' | 'info' | 'secondary' | 'primary' | 'warning' | 'error'
  href?: string
}

export const tmcMenuItems: MenuItem[] = [
  {
    title: 'Rawat Jalan',
    iconSrc: '/images/icon/outpatient.png',
    href: '/kunjungan/rawat-jalan#Kunjungan Rawat Jalan',
    color: 'primary'
  },
  {
    title: 'Rawat Inap',
    iconSrc: '/images/icon/inpatient.png',
    href: '/kunjungan/rawat-inap#Kunjungan Rawat Inap',
    color: 'primary'
  },
  {
    title: 'Rajal & Ranap',
    iconSrc: '/images/icon/healthcare.png',
    href: '/kunjungan/rajal-ranap#Kunjungan Rajal & Ranap',
    color: 'primary'
  },
  {
    title: 'Pulang Rajal',
    iconSrc: '/images/icon/patient_go.png',
    href: '/kunjungan/pulang-rajal#Pulang Rajal',
    color: 'primary'
  },
  {
    title: 'Pulang Ranap',
    iconSrc: '/images/icon/outpatient_go.png',
    href: '/kunjungan/pulang-ranap#Pulang Ranap',
    color: 'primary'
  }
]

export const sdpMenuItems: MenuItem[] = [
  {
    title: 'Home',
    iconSrc: '/images/icon/house.png',
    href: '/home#Home',
    color: 'primary'
  },
  {
    title: 'List Radiologi',
    iconSrc: '/images/icon/x-ray.png',
    href: '/list-radiologi#List Radiologi',
    color: 'primary'
  }
]

export const perawatanItems: MenuItem[] = [
  {
    title: 'Perawatan',
    iconSrc: '/images/icon/inpatient.png',
    href: '/rawat/rawat#Perawatan',
    color: 'primary'
  },
  {
    title: 'Pasien Pulang',
    iconSrc: '/images/icon/outpatient.png',
    href: '/rawat/rawat#Pasien Pulang',
    color: 'primary'
  }
]

export const pendapatanItems: MenuItem[] = [
  {
    title: 'Biaya Tahunan',
    iconSrc: '/images/icon/budget.png',
    href: '/biaya#Biaya Tahunan',
    color: 'primary'
  },
  {
    title: 'Pendapatan Tahunan',
    iconSrc: '/images/icon/financial-statement.png',
    href: '/pendapatan#Pendapatan Tahunan',
    color: 'primary'
  },
  {
    title: 'Pendapatan Rincian',
    iconSrc: '/images/icon/financial-statement.png',
    href: '/pendapatan-rincian#Pendapatan Rincian',
    color: 'primary'
  },
  {
    title: 'Pendapatan & Biaya',
    iconSrc: '/images/icon/accounting.png',
    href: '/keuangan#Pendapatan & Biaya',
    color: 'primary'
  },
  {
    title: 'Pendapatan Tiap Dokter',
    iconSrc: '/images/icon/doctor.png',
    href: '/keuangan#Pendapatan Tiap Dokter',
    color: 'primary'
  },
  {
    title: 'Verifikasi Billing BPJS',
    iconSrc: '/images/icon/icon_bpjs.png',
    href: '/keuangan#Verifikasi Billing BPJS',
    color: 'primary'
  }
]

export const operasiItems: MenuItem[] = [
  {
    title: 'Bedah',
    iconSrc: '/images/icon/surgery-room.png',
    href: '/operasi#Bedah',
    color: 'primary'
  },
  {
    title: 'Anastesi',
    iconSrc: '/images/icon/anesthesia.png',
    href: '/operasi#Anastesi',
    color: 'primary'
  },
  {
    title: 'Spesialisasi',
    iconSrc: '/images/icon/surgeon.png',
    href: '/operasi#Spesialisasi',
    color: 'primary'
  }
]

export const rekamMedisItems: MenuItem[] = [
  {
    title: 'Penyakit Terbanyak',
    iconSrc: '/images/icon/disease.png',
    href: '/rekam-medis#Penyakit Terbanyak',
    color: 'primary'
  }
]

// export const biayaItems: MenuItem[] = [
//   {
//     title: 'Biaya',
//     iconSrc: '/images/icon/accounting.png',
//     href: '/biaya#Biaya',
//     color: 'error'
//   }
// ]
